module.exports = __webpack_public_path__ + "e8d373efcaf957e730851e016431ccfc.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/stat-location.png
// module id = 177
// module chunks = 0